export { generator } from './generator.js';
export { componentGenerator } from './component-generator.js';
export type { ComponentGenerationResult } from './component-generator.js';
export {
  dependenciesUpdater,
  ensureMinimumDependencies,
} from './dependencies-updater.js';
